/**
 * Created by charnjeetelectrovese@gmail.com on 5/1/2020.
 */

import {postRequest} from "../libs/AxiosService.util";
import axios from "axios";
import Constants from "../config/constants";

export async function serviceGetAppSettings(params) {
    return await postRequest('app/setting', params);
}

export async function serviceUpdateGeoFence(params) {
    return await postRequest('app/settings/geofence/update', params);
}

export async function serviceUpdatePolicies(params) {
    return await postRequest('app/setting/update/policies', params);
}
export async function serviceLoginUsingGoogleAuth (params) {
    return await postRequest('/auth/social/login', params);
}

export async function serviceGetThemeByDomain() {
    let baseUrl = Constants.DEFAULT_APP_URL;
    if (baseUrl.includes('/api/')) {
        baseUrl = baseUrl.substring(0, baseUrl.indexOf('/api/') + 5);
    }
    const url = baseUrl + 'admin/clients/theme-by-domain';
    return await axios.post(url);
}
